import { register } from "../helpers/stimulus"

import ConsentBannerController from "../controllers/consent_banner_controller"
import DisclosureItemController from "../controllers/disclosure_item_controller"
import FooterController from "../controllers/footer_controller"

const ONETRUST = document.body.getAttribute("data-onetrust") === "true"

const setupFooter = (): void => {
  if (ONETRUST) {
    register("consent-banner", ConsentBannerController)
  }

  register("disclosure-item", DisclosureItemController)
  register("footer", FooterController)
}

export { setupFooter }
